/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService
 */

export const AgentConfigChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.AgentConfigChirpContentBlock';
export const AgentConfigChirpContentBlockDiscriminant = 'AGENT_CONFIG';
export const AgentConfigChirpContentBlockDiscriminantKey = 'type';
export const AviatorChirpContentBlockDiscriminantKey = 'type';
export const ContextChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ContextChirpContentBlock';
export const ContextChirpContentBlockDiscriminant = 'CONTEXT';
export const ContextChirpContentBlockDiscriminantKey = 'type';
export const DisplayOnlyChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.DisplayOnlyChirpContentBlock';
export const DisplayOnlyChirpContentBlockDiscriminant = 'DISPLAY_ONLY';
export const DisplayOnlyChirpContentBlockDiscriminantKey = 'type';
export const FileChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.FileChirpContentBlock';
export const FileChirpContentBlockDiscriminant = 'FILE';
export const FileChirpContentBlockDiscriminantKey = 'type';
export const ImageChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ImageChirpContentBlock';
export const ImageChirpContentBlockDiscriminant = 'IMAGE';
export const ImageChirpContentBlockDiscriminantKey = 'type';
export const ImageToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ImageToolResultChirpContentBlock';
export const ImageToolResultChirpContentBlockDiscriminant = 'IMAGE_TOOL_RESULT';
export const ImageToolResultChirpContentBlockDiscriminantKey = 'type';
export const PdfChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.PdfChirpContentBlock';
export const PdfChirpContentBlockDiscriminant = 'PDF';
export const PdfChirpContentBlockDiscriminantKey = 'type';
export const PendingToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.PendingToolResultChirpContentBlock';
export const PendingToolResultChirpContentBlockDiscriminant = 'PENDING_TOOL_RESULT';
export const PendingToolResultChirpContentBlockDiscriminantKey = 'type';
export const RedactedThinkingChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.RedactedThinkingChirpContentBlock';
export const RedactedThinkingChirpContentBlockDiscriminant = 'REDACTED_THINKING';
export const RedactedThinkingChirpContentBlockDiscriminantKey = 'type';
export const ServerToolUseChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ServerToolUseChirpContentBlock';
export const ServerToolUseChirpContentBlockDiscriminant = 'SERVER_TOOL_USE';
export const ServerToolUseChirpContentBlockDiscriminantKey = 'type';
export const TextChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.TextChirpContentBlock';
export const TextChirpContentBlockDiscriminant = 'TEXT';
export const TextChirpContentBlockDiscriminantKey = 'type';
export const ThinkingChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ThinkingChirpContentBlock';
export const ThinkingChirpContentBlockDiscriminant = 'THINKING';
export const ThinkingChirpContentBlockDiscriminantKey = 'type';
export const ToolApprovalRequestChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolApprovalRequestChirpContentBlock';
export const ToolApprovalRequestChirpContentBlockDiscriminant = 'TOOL_APPROVAL_REQUEST';
export const ToolApprovalRequestChirpContentBlockDiscriminantKey = 'type';
export const ToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolResultChirpContentBlock';
export const ToolResultChirpContentBlockDiscriminant = 'TOOL_RESULT';
export const ToolResultChirpContentBlockDiscriminantKey = 'type';
export const ToolUseChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolUseChirpContentBlock';
export const ToolUseChirpContentBlockDiscriminant = 'TOOL_USE';
export const ToolUseChirpContentBlockDiscriminantKey = 'type';
export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export const listConversationsRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'listConversations',
  auth: 'app',
  fingerprint: 'gFD946Aed0YDq1_3SX9h70H3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getConversation',
  auth: 'app',
  fingerprint: 'DuyxfCHhtPmIiCyWuytM9EH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConversationsByIdsRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getConversationsByIds',
  auth: 'app',
  fingerprint: 'IOkS6z72Xa6yt0fRjWEDXkH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConversationStatusesRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getConversationStatuses',
  auth: 'app',
  fingerprint: 'HEnU9DXCi9O3QNsr_l0iZ0H3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'deleteConversation',
  auth: 'app',
  fingerprint: 'Ad5bOGVxNpOOUe2e_r4XmUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const renameConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'renameConversation',
  auth: 'app',
  fingerprint: 'FSQshBcIox2OUe2e_r4XmUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const shareConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'shareConversation',
  auth: 'app',
  fingerprint: 'tqqOq1B6yKaOUe2e_r4XmUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const revokeConversationShareRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'revokeConversationShare',
  auth: 'app',
  fingerprint: 'rgIvUH6ErouOUe2e_r4XmUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConversationSharesRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getConversationShares',
  auth: 'app',
  fingerprint: 'zUK_Vrm37gcGP8oVd-sYm0H3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'createConversation',
  auth: 'app',
  fingerprint: 'SLXRyRPOoZgMpSk9ohwxZUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMessageRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getMessage',
  auth: 'app',
  fingerprint: 'bgopicGDDcwkwDOnIboEVkH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMessagePayloadRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getMessagePayload',
  auth: 'app',
  fingerprint: 'rTbNkRv40g80_533PNZUXUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateCollectionIdRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'updateCollectionId',
  auth: 'app',
  fingerprint: 'zNJbsKdDoxWOUe2e_r4XmUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const appendTranscriptRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'appendTranscript',
  auth: 'app',
  fingerprint: 'OjeaJ5ygTwR8vGAgRqENjkH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const forkConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'forkConversation',
  auth: 'app',
  fingerprint: 'FqbnXljTlnkU3iinUGUzrUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchConversationsRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'searchConversations',
  auth: 'app',
  fingerprint: '0sYSQfzRdCX6LIw_2Tf67kH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const markConversationReadRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'markConversationRead',
  auth: 'app',
  fingerprint: '__y8xApXWTuOUe2e_r4XmUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hasUnreadConversationsRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'hasUnreadConversations',
  auth: 'app',
  fingerprint: 'HCgb9XLbROE_qqLscHYwj0H3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};